import React from 'react';

import { Badge, Text } from '@change/ds-core-ui';

import { translationKey } from '@change-corgi/core/i18n';
import { Translate } from '@change-corgi/core/react/i18n';

import { useEasyBrief } from './hooks/useEasyBrief';

export const EasyBrief: React.FC = () => {
	const {
		data: { briefs },
	} = useEasyBrief();

	return (
		<div className="text-typography-strong container py-6 text-center md:py-12">
			<Text as="h2" variant="heading">
				<Translate value={translationKey('corgi.homepage.how_to_sunrise.easy_brief.title')} />
			</Text>

			<div className="relative mt-4 flex flex-col justify-center gap-8 md:mt-10 md:flex-row">
				{briefs.map((brief, index) => (
					<div key={brief.key} className="relative flex flex-1 flex-row gap-4 md:flex-col md:gap-0">
						{index !== briefs.length - 1 && (
							<>
								<div className="border-stroke-strong absolute top-4 left-1/2 hidden w-[calc(100%-2rem)] translate-x-8 border-t-2 border-dotted md:block" />
								<div className="border-stroke-strong absolute top-10 left-4 block h-[calc(100%-1rem)] border-l-2 border-dotted md:hidden md:h-[calc(100%-2rem)]" />
							</>
						)}

						<div className="justify-left relative flex items-start md:items-center md:justify-center">
							<Badge
								label={
									<Text variant="heading" size="x-small" fontWeight="bold" className="mb-0.5">
										{index + 1}
									</Text>
								}
								variant="information"
								size="medium"
								className="h-8 w-8 justify-center"
							/>
						</div>

						<div className="text-left md:mt-1 md:text-center">
							<Text as="div" fontWeight="bold" variant="body">
								<Translate value={brief.titleKey} />
							</Text>
							<Text variant="body">
								<Translate value={brief.descriptionKey} />
							</Text>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};
